export default (primaryUrl, fallbackUrl, callback) => {
    $.getJSON(primaryUrl)
        .done(data => {
            // array || <ie8 fallback || >=ie9,chrome...
            if (data.length > 0 || !Object.keys || (Object.keys(data).length > 0)) {
                callback(data);
            } else { // Get fallback if zero items
                if (fallbackUrl) {
                    $.getJSON(fallbackUrl).done(data => callback(data));
                }
            }
        })
        .fail(( /* jqXHR, textStatus, errorThrown */ ) => {
            // On primary source fail get fallback
            if (fallbackUrl) {
                $.getJSON(fallbackUrl).done(data => callback(data));
            }
        });
};